import FAQ from "./components/FAQ";

export default store => ({
  path: "faq",
  component: FAQ
});



// WEBPACK FOOTER //
// ./src/routes/FAQ/index.js